import {
  ReadingSkillsPerformanceFilters,
  ReadingSkillsPerformanceResponse,
} from "@/reports/types";

export const readingSkillsPerformanceMockFilter: ReadingSkillsPerformanceFilters =
  {
    entity_type: "classroom",
    min_date: "2023-08-01",
    max_date: "2024-07-08",
    entity_id: "3837593837593837593837idjw538375",
  };

export const studentReadingSkillsPerformanceMockFilter: ReadingSkillsPerformanceFilters =
  {
    entity_type: "classroom",
    entity_id: "3bbdf574063e493ca0f059528204d50f",
    min_date: "2024-01-01",
    max_date: "2024-10-10",
    entity_filter_ids: "152535abcdef352515",
    entity_filter_type: "student",
  };

export const readingSkillsPerformanceMock: ReadingSkillsPerformanceResponse = {
  data: {
    filters_applied: readingSkillsPerformanceMockFilter,
    data: {
      total_items: 50,
      entities: {
        d2b8c7330352443e94f94164d8d83833: {
          name: { first: "Sarah", last: "Baker" },
          skills: [
            {
              average_question_score: 58.98,
              question_count: 133776,
              skill_content_id: "ckmmfdxcj00033e5aq2r9soen",
              skill_integer: 2,
              skill_name: "Main Idea, key details, summarization",
              student_count: 1,
            },
          ],
        },
        d2b8c7330352443e94f94164d8d83834: {
          name: { first: "Jennifer", last: "Fowler" },
          skills: [
            {
              average_question_score: 34.45,
              question_count: 12546,
              skill_content_id: "xytzfdxcj00033e5aq2r9abcd",
              skill_integer: 3,
              skill_name: "Connecting people",
              student_count: 1,
            },
          ],
        },
        d2b8c7330352443e94f94164d8d83835: {
          name: { first: "Vanessa", last: "Kramer" },
          skills: [
            {
              average_question_score: 16.45,
              question_count: 11300,
              skill_content_id: "xytzfdxcj00033e5aq2r9abcd",
              skill_integer: 3,
              skill_name: "Connecting people",
              student_count: 1,
            },
          ],
        },
        d2b8c7330352443e94f94164d8d83836: {
          name: { first: "Andrew", last: "Parker" },
          skills: [
            {
              average_question_score: 68,
              question_count: 17200,
              skill_content_id: "xytzfdxcj00033e5aq2r9abcd",
              skill_integer: 3,
              skill_name: "Connecting people",
              student_count: 1,
            },
          ],
        },
        a1f2d3c4b5e66789f0123456789abcde: {
          name: { first: "Sophia", last: "Williams" },
          skills: [
            {
              average_question_score: 68,
              question_count: 17200,
              skill_content_id: "xytzfdxcj00033e5aq2r9abcd",
              skill_integer: 3,
              skill_name: "Connecting people",
              student_count: 1,
            },
          ],
        },
        b2e3f4g5h6i77890a123456789abcdef: {
          name: { first: "Liam", last: "Johnson" },
          skills: [
            {
              average_question_score: 68,
              question_count: 17200,
              skill_content_id: "xytzfdxcj00033e5aq2r9abcd",
              skill_integer: 3,
              skill_name: "Connecting people",
              student_count: 1,
            },
          ],
        },
        c3d4e5f6g7h88901b23456789abcdef: {
          name: { first: "Emma", last: "Brown" },
          skills: [
            {
              average_question_score: 68,
              question_count: 17200,
              skill_content_id: "xytzfdxcj00033e5aq2r9abcd",
              skill_integer: 3,
              skill_name: "Connecting people",
              student_count: 1,
            },
          ],
        },
        d4e5f6g7h8i99012c3456789abcdef: {
          name: { first: "Noah", last: "Davis" },
          skills: [
            {
              average_question_score: 68,
              question_count: 17200,
              skill_content_id: "xytzfdxcj00033e5aq2r9abcd",
              skill_integer: 3,
              skill_name: "Connecting people",
              student_count: 1,
            },
          ],
        },
        e5f6g7h8i9j00123d456789abcdef: {
          name: { first: "Olivia", last: "Miller" },
          skills: [
            {
              average_question_score: 68,
              question_count: 17200,
              skill_content_id: "xytzfdxcj00033e5aq2r9abcd",
              skill_integer: 3,
              skill_name: "Connecting people",
              student_count: 1,
            },
          ],
        },
        f6g7h8i9j0k11234e56789abcdef: {
          name: { first: "James", last: "Wilson" },
          skills: [
            {
              average_question_score: 68,
              question_count: 17200,
              skill_content_id: "xytzfdxcj00033e5aq2r9abcd",
              skill_integer: 3,
              skill_name: "Connecting people",
              student_count: 1,
            },
          ],
        },
      },
      newsela: [
        {
          average_question_score: 78.54,
          question_count: 143576,
          skill_content_id: "ckmmfdxcj00033e5aq2r9soen",
          skill_integer: 2,
          skill_name: "Main Idea, key details, summarization",
          student_count: 1,
        },
        {
          average_question_score: 50.54,
          question_count: 133576,
          skill_content_id: "ckmmfdxcj00033e5aq2r9soex",
          skill_integer: 2,
          skill_name: "Connecting people",
          student_count: 1,
        },
      ],
    },
  },
};

export const studentReadingSkillsPerformanceMock: ReadingSkillsPerformanceResponse =
  {
    data: {
      filters_applied: studentReadingSkillsPerformanceMockFilter,
      data: {
        total_items: 50,
        entities: {
          "152535abcdef352515": {
            name: { first: "Jean", last: "Carneiro" },
            skills: [
              {
                average_question_score: 58.98,
                question_count: 133776,
                skill_content_id: "ckmmfdxcj00033e5aq2r9soen",
                skill_integer: 1,
                skill_name: "What the text says",
                student_count: 1,
              },
              {
                average_question_score: 58.98,
                question_count: 133776,
                skill_content_id: "ckmmfdxcj00033e5aq2r9soen",
                skill_integer: 2,
                skill_name: "Main idea, key details, summarization",
                student_count: 1,
              },
              {
                average_question_score: 58.98,
                question_count: 133776,
                skill_content_id: "ckmmfdxcj00033e5aq2r9soen",
                skill_integer: 3,
                skill_name: "Connecting people, events & ideas",
                student_count: 1,
              },
              {
                average_question_score: 58.98,
                question_count: 133776,
                skill_content_id: "ckmmfdxcj00033e5aq2r9soen",
                skill_integer: 4,
                skill_name: "Word meaning & choice",
                student_count: 1,
              },
              {
                average_question_score: null,
                question_count: 0,
                skill_content_id: "ckmmfdxcj00033e5aq2r9soen",
                skill_integer: 5,
                skill_name: "Text structure",
                student_count: 1,
              },
              {
                average_question_score: 58.98,
                question_count: 133776,
                skill_content_id: "ckmmfdxcj00033e5aq2r9soen",
                skill_integer: 6,
                skill_name: "Point of view and purpose",
                student_count: 1,
              },
              {
                average_question_score: 58.98,
                question_count: 133776,
                skill_content_id: "ckmmfdxcj00033e5aq2r9soen",
                skill_integer: 7,
                skill_name: "Interpret multimedia",
                student_count: 1,
              },
              {
                average_question_score: 58.98,
                question_count: 133776,
                skill_content_id: "ckmmfdxcj00033e5aq2r9soen",
                skill_integer: 8,
                skill_name: "Arguments and claims",
                student_count: 1,
              },
            ],
          },
        },
        newsela: [
          {
            skill_name: "Main idea, key details, summarization",
            skill_integer: 2,
            skill_content_id: "ckmmfdxcj00033e5aq2r9soen",
            average_question_score: 57.97,
            student_count: 4501,
            question_count: 30840,
          },
        ],
      },
    },
  };
